import { Tooltip } from "@mui/material";
import React from "react";

type TooltipProps = {
    title: any, 
    children: any
}
export const ToolTip=({title, children}: TooltipProps)=><Tooltip title={title}>{children}</Tooltip>